    <div class="menu-container">
      <ng-container *ngFor="let nav of navigationList; let i = index">
        <div class="menu-item" *ngIf="!(nav.label.startsWith('facebook')) && 
               !(nav.label.startsWith('instagram')) &&
               !(nav.label.startsWith('tiktok')) &&
               !(nav.label.startsWith('twitter')) &&
               !(nav.label.startsWith('reddit')) &&
               !(nav.label.startsWith('youtube'))" 
               (click)="navigateToRoute(nav.navigation)">
        <div class="menu-icon">
          <fa-icon [icon]="getIcon(nav.icon)" size="2x"></fa-icon>
        </div>
        <div class="menu-content">
          <span class="menu-title">{{nav.label}}</span>
        </div>
      </div>
      </ng-container>

      <div class="menu-item">
        <div class="menu-icon">
          <fa-icon [icon]="faBarChart" size="2x"></fa-icon>
        </div>
        <div class="menu-content">
          <span class="menu-title">
            <a href="{{dataVizUrl}}" target="_blank" rel="noopener noreferrer">DataViz Platform</a>
          </span>
        </div>
        <div class="menu-arrow">
          <fa-icon [icon]="faExternalLink" size="1x"></fa-icon>
        </div>
      </div>

      <div class="menu-item">
        <div class="menu-icon">
          <fa-icon [icon]="faBrain" size="2x"></fa-icon>
        </div>
        <div class="menu-content">
          <span class="menu-title">
            <a href="{{sentimentAnalyzerUrl}}" target="_blank" rel="noopener noreferrer">Sentiment Analyzer</a>
          </span>
        </div>
        <div class="menu-arrow">
          <fa-icon [icon]="faExternalLink" size="1x"></fa-icon>
        </div>
      </div>
      
    </div>